// extracted by mini-css-extract-plugin
module.exports = {"questionsContainer":"Questions_questionsContainer__3hQhu","fetchButton":"Questions_fetchButton__83mQD"};